export const categories = [
  {
    id: 'jiaoyou',
    slug: 'jiaoyou',
    name: '交友认识',
    description: '找到志同道合的伙伴，开启真实美好的邂逅',
    icon: 'ri-heart-line',
    color: 'primary',
    articleCount: 128,
  },
  {
    id: 'shequn',
    slug: 'shequn',
    name: '社群互动',
    description: '参与话题讨论，分享生活点滴，构建温暖社群',
    icon: 'ri-group-line',
    color: 'accent',
    articleCount: 96,
  },
  {
    id: 'shenghuo',
    slug: 'shenghuo',
    name: '生活资讯',
    description: '关注男同生活方方面面，提升生活品质与幸福感',
    icon: 'ri-home-heart-line',
    color: 'secondary',
    articleCount: 85,
  },
  {
    id: 'jiankang',
    slug: 'jiankang',
    name: '健康指南',
    description: '专业健康知识科普，关爱身心健康每一面',
    icon: 'ri-heart-pulse-line',
    color: 'primary',
    articleCount: 72,
  },
  {
    id: 'huodong',
    slug: 'huodong',
    name: '活动资讯',
    description: '全国各地男同活动汇总，精彩生活不等待',
    icon: 'ri-calendar-event-line',
    color: 'accent',
    articleCount: 54,
  },
  {
    id: 'xinli',
    slug: 'xinli',
    name: '心理成长',
    description: '自我认同、情感成长、心理疏导与专业支持',
    icon: 'ri-mental-health-line',
    color: 'secondary',
    articleCount: 63,
  },
];